export enum LoanDocumentEnum {
  GAP_CONTRACT = 'GAP_CONTRACT',
  RIC = 'RIC',
  SERVICE_CONTRACT = 'SERVICE_CONTRACT',
}
